import { jsx, jsxs } from 'react/jsx-runtime';
import s from '../../node_modules/classnames/index.js';
import { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import useMountTransition from './useMountTransition.js';

function createPortalRoot() {
    const drawerRoot = document.createElement('div');
    drawerRoot.setAttribute('id', 'drawer-root');
    return drawerRoot;
}
const Drawer = ({ isOpen, children, className, onClose, position = 'left', removeWhenClosed = true, preventDismissal = false, }) => {
    const bodyRef = useRef(document.querySelector('body'));
    const portalRootRef = useRef(document.getElementById('drawer-root') || createPortalRoot());
    const isTransitioning = useMountTransition(isOpen, 300);
    // Append portal root on mount
    useEffect(() => {
        if (!bodyRef.current)
            return;
        bodyRef.current.appendChild(portalRootRef.current);
        return () => {
            // Clean up the portal when drawer component unmounts
            portalRootRef.current.remove();
            // Ensure scroll overflow is removed
            if (bodyRef.current)
                bodyRef.current.style.overflow = '';
        };
    }, []);
    // Prevent page scrolling when the drawer is open
    useEffect(() => {
        const updatePageScroll = () => {
            if (!bodyRef.current)
                return;
            if (isOpen) {
                bodyRef.current.style.overflow = 'hidden';
            }
            else {
                bodyRef.current.style.overflow = '';
            }
        };
        updatePageScroll();
    }, [isOpen]);
    // Allow Escape key to dismiss the drawer if preventDismissal is false
    useEffect(() => {
        const onKeyPress = (e) => {
            if (e.key === 'Escape' && !preventDismissal) {
                onClose();
            }
        };
        if (isOpen) {
            window.addEventListener('keyup', onKeyPress);
        }
        return () => {
            window.removeEventListener('keyup', onKeyPress);
        };
    }, [isOpen, onClose]);
    if (!isTransitioning && removeWhenClosed && !isOpen) {
        return null;
    }
    return createPortal(jsx("div", { children: jsxs("div", Object.assign({ "aria-hidden": isOpen ? 'false' : 'true', className: s('drawer-container', {
                open: isOpen,
                in: isTransitioning,
                className,
            }) }, { children: [jsx("div", Object.assign({ className: s('drawer', position), role: "dialog" }, { children: children }), void 0), jsx("div", { className: "backdrop", onClick: () => {
                        if (!preventDismissal) {
                            onClose();
                        }
                    } }, void 0)] }), void 0) }, void 0), portalRootRef.current);
};

export { Drawer };
